import { createSelector } from "@ngrx/store";
import * as SupplierSelectors from "@app/shared/state/supplier/supplier.selectors";

export const selectFirstDraftSupplierEsn = createSelector(
  SupplierSelectors.selectDraftSupplierEsns,
  (draftSupplierEsns) =>
    draftSupplierEsns.length > 0 ? draftSupplierEsns[0] : null,
);
